<div fxLayout="row" fxLayoutAlign="space-between center" class="w-100">
    <div class="t2 c-primary-gray-900">{{ 'i18n_lib_commonLabelTime' | translate }}:</div>
    <div fxLayout="row" fxLayoutAlign="end center">
        <mat-form-field class="time-input">
            <input commonsMaterialInput
                   data-testid="filter-period-time-from"
                   [formControl]="startControl"
                   [showMaskTyped]="true"
                   [dropSpecialCharacters]="false"
                   [leadZeroDateTime]="true"
                   mask="Hh:m0">
        </mat-form-field>
        <div class="ml-8 mr-8">-</div>
        <mat-form-field class="time-input">
            <input commonsMaterialInput
                   data-testid="filter-period-time-to"
                   [formControl]="endControl"
                   [showMaskTyped]="true"
                   [dropSpecialCharacters]="false"
                   [leadZeroDateTime]="true"
                   mask="Hh:m0">
        </mat-form-field>
    </div>
</div>
